module.exports = __webpack_public_path__ + "img/broken-image.d0357e0d.svg";